import React from 'react';
import { Header, Divider } from 'semantic-ui-react';
import MenuUtil from '../../../utils/menu';
import { MenuConsumer } from '../../../FoodMenu.context';

const ItemBasicCondensed = ({ itemId }) => {
  return <div />;
};

export default ItemBasicCondensed;
